import { useState } from "react";
import { DogSignUp } from "./DogSignUp";
import TrialList from "./TrialList";
import TrialRegisterDogsList from "./TrialRegisterDogs";
import TrialDetail from "shared/Trail/TrialDetail";

export const TrialCalendar = () => {
  const [selectedTrial, setTrial] = useState(null);
  const [viewEntries, setViewEntries] = useState(null);
  
  const [dogSignUp, setDogSignup] = useState(false);

  return (
    <div className="App rounded-md min-h-screen lg:ml-[17rem] sm:pt-8 bg-white lg:p-10">
      {selectedTrial && !dogSignUp && !viewEntries ? (
        <TrialDetail
          goBack={() => setTrial(null)}
          detail={selectedTrial}
          setDogSignup={setDogSignup}
        />
      ) : dogSignUp ? (
        <DogSignUp
          detail={selectedTrial}
          setDogSignup={(dogSignUpData) => {
            setDogSignup(dogSignUpData);
            if (!dogSignUpData) {
              setTrial(null);
            }
          }}
        />
      ) : viewEntries ? (
        <TrialRegisterDogsList
          setViewEntries={setViewEntries}
          viewEntriesData={viewEntries}
        />
      ) : (
        <TrialList setViewEntries={setViewEntries} setTrial={setTrial} />
      )}
    </div>
  );
};
